import script from "./SentenceBuilderGame.vue?vue&type=script&setup=true&lang=js"
export * from "./SentenceBuilderGame.vue?vue&type=script&setup=true&lang=js"

import "./SentenceBuilderGame.vue?vue&type=style&index=0&id=9b0a0326&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b0a0326"]])

export default __exports__